import React from 'react';
import styled from 'styled-components';
import Link from '../components/Link';
import { FormattedMessage, injectIntl } from 'react-intl';

import BecomeExhibitorButton from '../components/BecomeExhibitorButton';
import Sponsor from '../components/Sponsor';
import Banners from '../components/Banners';
import { breakpoints } from '../constants';
import ScheduleWidget from '../components/ScheduleWidget';

import Covid19UpdateButton from '../components/Covid19UpdateButton';

import aboutBackground from './assets/about-background.png';
import exhibitorsBackground from './assets/exhibitors-background-colored.jpg';
import exhibitorsExhibitorsMobileBackground from './assets/exhibitors-background-colored-exhibitors-mob.jpg';
import aircrafts from './assets/aircrafts.svg';
import visitors from './assets/visitors.svg';
import conference from './assets/conference.png';
import marketing from './assets/marketing.svg';
import attendeeNavigationImage from './assets/attendee.jpg';
import exhibitorsNavigationImage from './assets/exhibitors.jpg';
import opportunitiesNavigationImage from './assets/opportunities.jpg';
import favtBannerImage from './assets/FAVT_banner.png';
import favtBannerTabletImage from './assets/FAVT_banner_tablet.png';
import favtBannerMobileImage from './assets/FAVT_banner_mobile.png';
import bermudaRegistrationEnImage from './assets/registerBermudaEn.gif';
import bermudaRegistrationRuImage from './assets/registerBermudaRu.gif';

const About = styled.section`
    background: url(${aboutBackground}) -81px top no-repeat no-repeat;
    min-height: 557px;
    padding: 35px 200px 90px;
    p {
        text-align: justified;
    }
    h1,
    h2 {
        color: #003056;
        font-size: 1.7rem;
        font-weight: 600;
        line-height: 1.5;
        word-break: break-word;
        margin-bottom: 0.5rem;
    }

    @media (max-width: ${breakpoints.tablet}) {
        background: none;
        padding: 2rem 50px 3rem;
    }

    @media (max-width: ${breakpoints.mobile}) {
        padding: 1rem 20px 2rem;
        text-align: justify;
        h1,
        h2 {
            font-size: 1.3rem;
            text-align: left;
        }
    }
`;

const Exhibitors = styled.section`
    background: url(${exhibitorsBackground}) center bottom no-repeat no-repeat;
    height: 470px;
    text-align: justify;
    p {
        margin-bottom: 1rem;
    }
    h2,
    h3,
    h4 {
        font-size: 1.5rem;
        line-height: 1.5;
        font-weight: 600;
        margin-bottom: 1.5rem;
    }
    @media (max-width: ${breakpoints.tablet}) {
        height: auto;
    }

    .column:first-of-type {
        // Exhibitors
        padding-left: 200px;
        padding-bottom: 30px;
        display: flex;
        flex-direction: column;
        a {
            color: white;
            &.button {
                align-self: flex-start;
                color: #003056;
            }
        }

        @media (max-width: ${breakpoints.tablet}) {
            padding: 2rem 50px 3rem;
            background: url(${exhibitorsExhibitorsMobileBackground}) center
                bottom no-repeat no-repeat;
            background-size: cover;
        }
        @media (max-width: ${breakpoints.mobile}) {
            padding: 1rem 30px;
        }
    }
    .column:nth-of-type(2) {
        padding-left: 35px;
        padding-right: 45px;
        padding-bottom: 30px;
        display: flex;
        flex-direction: column;
        a {
            color: white;
            &.button {
                align-self: flex-start;
                color: #003056;
            }
        }

        @media (max-width: ${breakpoints.tablet}) {
            padding: 2rem 50px 3rem;
            background-color: #003056;
        }
        @media (max-width: ${breakpoints.mobile}) {
            padding: 1rem 30px;
        }
    }
    .column:nth-of-type(3) {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 200px;

        @media (max-width: ${breakpoints.tablet}) {
            padding: 0 50px 0;
            background-color: #bdcdd2;
        }
        @media (max-width: ${breakpoints.mobile}) {
            padding: 0 30px;
        }
    }
    p,
    h3,
    h4 {
        color: white;
    }
    h4 {
        margin-top: 20px;
    }
`;

const Sponsors = styled.section`
    //height: 570px;
    //height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 20px 200px 40px;
    h3 {
        flex: 1 0 100%;
        text-align: center;
        color: #003056;
        font-weight: bold;
        border-bottom: 1px solid #20bbef;
        line-height: 0;
        margin-top: 50px;
        margin-bottom: 1.5rem;
        span {
            background: #fff;
            padding: 0 10px;
        }
    }
    .break {
        flex: 1 0 100%;
    }

    @media (max-width: ${breakpoints.tablet}) {
        padding: 30px;
        h3 {
            font-size: 150%;
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        h3 {
            line-height: initial;
            border: none;
            position: relative;
        }
    }
`;

const AboutItems = styled.div`
    margin-bottom: 0.5rem;
    & .is-tablet {
        display: flex;
    }
    @media (max-width: ${breakpoints.tablet}) {
        margin: 1rem 0;
        /* & .is-half-tablet {
            width: 50%;
            flex: none;
        } */
    }
    @media (max-width: ${breakpoints.mobile}) {
        & .is-tablet {
            display: block;
        }
        /* & .is-full-mobile2 {
            flex: none;
            width: 100%;
        } */
    }
`;

const AboutItem = styled.div`
    p {
        line-height: 1.5;
        max-width: 120px;
        margin: 0 auto;
    }
    a {
        color: inherit;
    }
    img {
        height: 70px;
    }
`;

const Content = styled.div`
    flex: 1;
    .gatsby-resp-iframe-wrapper {
        margin-top: 30px;
    }
`;

const SidebarSponsors = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 1.5rem;
    div {
        width: 50%;
    }
`;

const SidebarGeneralSponsors = styled(SidebarSponsors)`
    margin-top: 0;
    div {
        width: 100%;
    }
`;

const NavigationButtons = styled.div`
    margin-top: 1rem;
`;

const NavigationButton = styled(Link)`
    height: 250px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    /* text-align: center; */
    background: #d5f3fd;
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    text-transform: uppercase;
    text-decoration: none;
    margin: 1rem 1rem 140px;
    padding: 0 1rem 0.5rem;
    cursor: pointer;
    background-size: cover;

    &:div:nth-of-type(1) {
        flex:1;

    }

    &:hover {
        color: white;
    }

    &:nth-of-type(1).favtBanner {
        height: 300px;
        background-image: url('${favtBannerImage}');
        background-repeat: no-repeat;
        background-size: 100%, 300px;
        margin-bottom: 0px;
        background-color: rgb(0,123,238);

        @media (max-width: ${breakpoints.tablet}) {
            height: auto;
            background-size: 100%, 100%;
            padding-top: 30%;
            background-image: url('${favtBannerTabletImage}');
        }
        @media (max-width: ${breakpoints.mobile}) {
            height: auto;
            padding-top: 67%        
            background-image: url('${favtBannerMobileImage}');
            background-size: 100%, 100%;
        }

    }
    &:nth-of-type(1) {

        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7) 20%, rgba(100, 100, 100, 0), 60%, rgba(100, 100, 100, 0)), url('${attendeeNavigationImage}');
    }
    &:nth-of-type(2) {
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 20%, rgba(100, 100, 100, 0), 60%, rgba(100, 100, 100, 0)), url('${exhibitorsNavigationImage}');
    }
    &:nth-of-type(3) {
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 20%, rgba(100, 100, 100, 0), 60%, rgba(100, 100, 100, 0)), url('${opportunitiesNavigationImage}');
    }
    &.bermuda {
        background-size: 100%;
        background-position: center; 
        background-repeat: no-repeat;
        background-color: white;

        @media (max-width: ${breakpoints.tablet}) {
            margin-bottom: 28px;
            background-position: center;
            background-size: contain;
            div {
                display: none;
                position: static;
            }
        }
    }
   
    &.bermuda.ru {
        background-image: url('${bermudaRegistrationRuImage}');
    }
    &.bermuda.en {
        background-image: url('${bermudaRegistrationEnImage}');
    }
    @media (max-width: ${breakpoints.tablet}) {
        /* height: 100px; */
        margin-bottom: 170px;
    }
`;

const NavigationButtonDescription = styled.div`
    font-size: 16px;
    font-weight: normal;
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    height: 140px;
    background: #003056;
    padding: 1rem;
    text-transform: none;
`;

const StyledCovid19UpdateButton = styled(Covid19UpdateButton)`
    /* position: absolute;*/
    background-color: red;
    font-weight: bold;
    border-color: red;
    color: white;
    width: auto;
    right: 200px;
    top: 300px;
    @media (max-width: ${breakpoints.tablet}) {
        top: 300px;
        right: 40px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        top: 305px;
        left: 20px;
    }
`;

const IndexContent = ({ intl, data }) => {
    let aboutBlock = data.contentfulPage.blocks.filter(
        (block) => block.name === 'about'
    );
    aboutBlock = !!aboutBlock.length && aboutBlock[0];
    let attendeeBlock = data.contentfulPage.blocks.filter(
        (block) => block.name === 'attendee'
    );
    attendeeBlock = !!attendeeBlock.length && attendeeBlock[0];
    let exhibitorsBlock = data.contentfulPage.blocks.filter(
        (block) => block.name === 'exhibitors'
    );
    exhibitorsBlock = !!exhibitorsBlock.length && exhibitorsBlock[0];
    const sponsors = data.sponsors.edges.filter(
        (edge) => edge.node.type === 'sponsors'
    )[0].node.items;
    const infoSponsors = data.sponsors.edges.filter(
        (edge) => edge.node.type === 'info-sponsors'
    )[0].node.items;
    const participants = data.sponsors.edges.filter(
        (edge) => edge.node.type === 'participants'
    )[0].node.items;
    const generalSponsors = data.sponsors.edges.filter(
        (edge) => edge.node.type === 'general-sponsors'
    )[0].node.items;

    const { banners } = data;

    return (
        <Content>
            <About>
                <AboutItems>
                    <div className="columns is-tablet">
                        <div className="columns column is-mobile">
                            <AboutItem className="column has-text-centered">
                                <img src={visitors} />
                                <p>
                                    <FormattedMessage id="about.visitors" />
                                </p>
                            </AboutItem>
                            <AboutItem className="column has-text-centered">
                                <img src={aircrafts} />
                                <p>
                                    <FormattedMessage id="about.aircrafts" />
                                </p>
                            </AboutItem>
                        </div>
                        <div className="columns column is-mobile">
                            <AboutItem className="column has-text-centered">
                                <img src={conference} />
                                <p>
                                    <FormattedMessage id="about.conference" />
                                </p>
                            </AboutItem>
                            <AboutItem className="column has-text-centered">
                                <img src={marketing} />
                                <p>
                                    <Link
                                        to={`/files/${
                                            intl.locale === 'ru'
                                                ? 'RUBAE_2021_rus.pdf'
                                                : 'RUBAE_2021_eng.pdf'
                                        }`}
                                    >
                                        <FormattedMessage id="about.marketing" />
                                    </Link>
                                </p>
                            </AboutItem>
                        </div>
                    </div>
                </AboutItems>
                <div className="columns">
                    <div className="column is-three-fifths">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: aboutBlock
                                    ? aboutBlock.content.childMarkdownRemark
                                          .html
                                    : '<p/>',
                            }}
                        />
                    </div>
                    <div className="column">
                        <ScheduleWidget style={{ marginTop: 35 }} intl />
                    </div>
                </div>

                <NavigationButtons className="columns">
                    <NavigationButton className="column" to="pages/attendee">
                        <FormattedMessage
                            id="about.navigation.attendee.title"
                            tagName="div"
                        />
                        <NavigationButtonDescription>
                            <FormattedMessage id="about.navigation.attendee.description" />
                        </NavigationButtonDescription>
                    </NavigationButton>
                    <NavigationButton className="column" to="pages/exhibitors">
                        <FormattedMessage id="about.navigation.exhibitors.title" />
                        <NavigationButtonDescription>
                            <FormattedMessage id="about.navigation.exhibitors.description" />
                        </NavigationButtonDescription>
                    </NavigationButton>
                    <NavigationButton
                        className="column"
                        to="pages/opportunities"
                    >
                        <FormattedMessage id="about.navigation.opportunities.title" />
                        <NavigationButtonDescription>
                            <FormattedMessage id="about.navigation.opportunities.description" />
                        </NavigationButtonDescription>
                    </NavigationButton>
                    <NavigationButton
                        className={'column bermuda ' + intl.locale}
                        to="https://www.bcaa.bm/contact-us"
                    >
                        <FormattedMessage id="about.navigation.registration.title" />
                        <NavigationButtonDescription>
                            <FormattedMessage id="about.navigation.registration.description" />
                        </NavigationButtonDescription>
                    </NavigationButton>
                    {/* <StyledCovid19UpdateButton
                         label={'COVID-19 safety rules'}
                         locale={intl.locale}
                     />*/}
                </NavigationButtons>
                <NavigationButtons className="columns">
                    <NavigationButton
                        className="column favtBanner"
                        to="/files/RUBAE2021-FAVT.pdf"
                    />
                </NavigationButtons>
            </About>

            <Sponsors>
                <h3>
                    <FormattedMessage id="sponsors" tagName="span" />
                </h3>
                {renderSponsors(sponsors, { maxHeight: '120px' })}
                <div className="break" />
                {renderSponsors(generalSponsors, {
                    showTitle: true,
                    maxHeight: '90px',
                })}
                <h3 style={{ 'margin-bottom': '50px' }}>
                    <FormattedMessage id="participants" tagName="span" />
                </h3>
                {renderSponsors(participants, { maxHeight: '100px' })}
                <h3>
                    <FormattedMessage id="info-sponsors" tagName="span" />
                </h3>
                {renderSponsors(infoSponsors, { maxHeight: '100px' })}
            </Sponsors>
        </Content>
    );
};

const renderSponsors = (
    sponsors,
    options = { maxHeight: 0, showTitle: false, vertical: false }
) =>
    sponsors.map((sponsor) => (
        <Sponsor
            key={sponsor.title}
            url={sponsor.link}
            img={sponsor.logo.file.url}
            title={options.showTitle && sponsor.title}
            maxHeight={options.maxHeight}
            vertical={options.vertical}
        />
    ));

export default injectIntl(IndexContent);

export const pageQuery = graphql`
    query indexTemplateQuery($id: String!, $node_locale: String!) {
        contentfulPage(id: { eq: $id }) {
            blocks {
                name
                content {
                    childMarkdownRemark {
                        html
                    }
                }
            }
        }

        sponsors: allContentfulSponsors(
            filter: { node_locale: { eq: $node_locale } }
        ) {
            edges {
                node {
                    type
                    items {
                        title
                        link
                        logo {
                            file {
                                url
                            }
                        }
                    }
                }
            }
        }

        banners: allContentfulBanner(
            filter: { page: { eq: "index" }, node_locale: { eq: $node_locale } }
        ) {
            edges {
                node {
                    link
                    banner {
                        file {
                            url
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/indexTemplate.js